import { Route } from '@angular/router';
import { AdminEditionComponent } from './admin-edition.component';
import { AuthGuard } from '../../../shared/services';
import { UserDetailsResolver } from '../user-details/user-details.resolver';
import { AssociationsListResolver } from '../../associations/associations-list/associations-list.resolver';

export const AdminEditionRoutes: Route[] = [
    {
      path: 'admin-edit/:id',
      component: AdminEditionComponent,
      canActivate: [AuthGuard],
      resolve: {
        user: UserDetailsResolver,
        associations: AssociationsListResolver
      }
    }
  ];
